export default __webpack_public_path__ + "static/media/5.28222f1a.jpg";